(() => {
  const mobileQuery = window.matchMedia('(max-width: 749px)');

  function destroyTrustSection(section) {
    if (!section || !section.swiper) return;
    section.swiper.destroy(true, true);
    delete section.swiper;
    delete section.dataset.swiperReady;
  }

  function initTrustSection(section) {
    if (!section || section.dataset.swiperReady === 'true') return;
    if (typeof Swiper === 'undefined' || !mobileQuery.matches) return;

    const container = section.querySelector('[data-sunster-rvac-trust-swiper]');
    const nextEl = section.querySelector('.sunster-rvac-trust__papers-nav--next');
    const prevEl = section.querySelector('.sunster-rvac-trust__papers-nav--prev');
    const slideCount = container?.querySelectorAll('.swiper-slide').length || 0;

    if (!container || !nextEl || !prevEl || !slideCount) return;

    const swiper = new Swiper(container, {
      initialSlide: 0,
      loop: false,
      slidesPerView: 'auto',
      centeredSlides: true,
      spaceBetween: 12,
      speed: 600,
      watchOverflow: true,
      navigation: {
        nextEl,
        prevEl,
      },
    });

    section.dataset.swiperReady = 'true';
    section.swiper = swiper;
  }

  function syncTrustSections(root = document) {
    root.querySelectorAll('[data-sunster-rvac-trust]').forEach((section) => {
      if (mobileQuery.matches) {
        initTrustSection(section);
      } else {
        destroyTrustSection(section);
      }
    });
  }

  function handleViewportChange() {
    syncTrustSections();
  }

  document.addEventListener('DOMContentLoaded', () => syncTrustSections());
  document.addEventListener('shopify:section:load', (event) => syncTrustSections(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-sunster-rvac-trust]').forEach(destroyTrustSection);
  });

  if (typeof mobileQuery.addEventListener === 'function') {
    mobileQuery.addEventListener('change', handleViewportChange);
  } else if (typeof mobileQuery.addListener === 'function') {
    mobileQuery.addListener(handleViewportChange);
  }
})();
